import gql from 'graphql-tag';
import Interface from '../Interface';
import { contentViewFields } from '../Content/ContentFields';
import {
  ContentsSchema,
  RoomJSONStructureSchema,
} from '../../definitions/schemas';

export interface RoomContentsListData {
  /**
   * Flattened structure of all openable room contents (root + folder-nested),
   * carrying the room-level display overrides (name, nameVisible,
   * isDownloadable, etc.). Same `{ items: [...] }` shape as `getRoom`/`getFolder`.
   */
  structure: RoomJSONStructureSchema;
  /** Underlying content records for the items above. */
  contents: ContentsSchema;
}

interface GetRoomContentsListResponse {
  getRoomContentsList: RoomContentsListData | null;
}

export default class RoomContentsListInterface extends Interface {
  public async getRoomContentsList(
    roomId: string
  ): Promise<RoomContentsListData | null> {
    const data = await this.query<GetRoomContentsListResponse>(
      () =>
        this.apolloService.executeQuery<GetRoomContentsListResponse>({
          query: gql`
            query getRoomContentsList($roomId: ID!) {
              getRoomContentsList(roomId: $roomId) {
                structure
                contents {
                  ${contentViewFields}
                }
              }
            }
          `,
          variables: { roomId },
        }),
      'Error loading room contents list'
    );

    return data.getRoomContentsList;
  }
}
